import React from "react";
import { Modal, Row, Col, Form } from 'react-bootstrap';

import ConditionalButton from "../../../../layout/conditional-button";
import { isGuid } from "../../../../utils/string";

import Card from "./card";

class ExModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: {
                notes: ""
            }
        }
    }

    onHideModal = (e) => {
        this.onCancel(e)
    }

    onCancel = async (e) => {
        this.props.onCancel(e);
    }

    onOk = (e) => {
        this.props.onOk(e, this.state.selected);
    }

    onCardClick = (e, item) => {
        this.setState({
            selected: {
                ...item,
                uuid: item.uuid,
                key: item.key,
                version: item.version,
                name: item.name,
                caption: item.caption,
                description: item.description || item.caption || item.fileName || "",
                category: item.category,
                output: item.output,
                fileName: item.fileName,
                notes: item?.meta?.release?.notes ?? "",
                flags: item?.meta?.release?.flags ?? 0,
                meta: item?.meta
            }
        })
    }

    canImport = (e) => {
        return isGuid(this.state.selected.uuid);
    }

    render() {
        if (!this.props.show) {
            return <></>
        }
        return (
            <Modal size="xl" backdrop="static" keyboard show={this.props.show} onHide={this.onHideModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="staticBackdropLabel">{this.props.title || `Import Survey`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="g-3">
                        <Col md="6" lg="8" xl="9" xxl="10"> 
                            <Row>
                                {this.props?.data?.map((item, index) => (
                                    <Col xxl="4" lg="6" key={item.uuid || index}>
                                        <Card title={item.name} text={item.description || item.caption || item.fileName} onClick={(e) => { this.onCardClick(e, item) }} />
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                        
                        <Col md="6" lg="4" xl="3" xxl="2">
                            <Form.Label>{ this.state.selected?.notes }</Form.Label>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <ConditionalButton enabledVariant="outline-primary" display enabled onEnabledClick={this.onCancel} icon="error-hexagon">cancel</ConditionalButton>
                    <ConditionalButton enabledVariant="outline-primary" display enabled={ this.canImport() } onEnabledClick={this.onOk} icon="save">import</ConditionalButton>
                </Modal.Footer>
            </Modal>
        );
    }
}


export default ExModal;
